import type { QuizSection } from '@repo/types/quiz';

import QuestionCard from '@/components/features/quiz/question/cards/QuestionCard';
import QuizSectionCardHeader from '@/components/features/quiz/quiz-resolver/QuizSectionCardHeader';
import { ElementLink } from '@/components/ui/scroll';

interface QuizSectionCardProps {
  section: QuizSection;
  sectionIndex: number;
  navigateTo?: (questionIndex: number) => void;
}

export default function QuizSectionCard(quizSectionCardProps: QuizSectionCardProps) {
  const { section, sectionIndex, navigateTo } = quizSectionCardProps;

  return (
    <div className="bg-surface-secondary flex flex-col gap-1 rounded-md p-1">
      <QuizSectionCardHeader name={section.name} />
      <div className="flex flex-col gap-1 empty:hidden">
        {section.questions.map((_question, index) => (
          <ElementLink key={index} to={`section-${sectionIndex}/question-${index}`} activeClass="bg-surface-primary border-border-brand" onClick={() => navigateTo?.(sectionIndex)} asChild>
            <QuestionCard questionIndex={index} />
          </ElementLink>
        ))}
      </div>
    </div>
  );
}
